import { IWithPageElementProps } from '../DashboardCustomizationDefinitions';

const withLeadingIndicatorsFromPageElement = (Indicators: React.ComponentType): React.FC<IWithPageElementProps> => {
    const Wrapped: React.FC<IWithPageElementProps> = () => <Indicators />;

    return Wrapped;
};

export default withLeadingIndicatorsFromPageElement;
